export default __webpack_public_path__ + "static/media/D4.6dca6c89.mp3";